import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private snackBar: MatSnackBar) { }

  openSnackBar(message,duration,htmlClass,horizontal,vertical) {
    this.snackBar.open(message, '', {
      duration: duration,
      panelClass: htmlClass,
      horizontalPosition: horizontal,
      verticalPosition: vertical
    });
  }
}
